export default "__VITE_ASSET__bnu_gm3y__"